import { UserParams } from 'src/domain/User/UserDomain'
import { ChangePasswordDto, UserDto } from 'src/dto/user.dto'
import { UserService } from 'src/services/api/user.service'
import { LoginResponse } from 'src/contexts/auth/types'

export class UserController {
  private service: UserService

  constructor() {
    this.service = new UserService()
  }

  public async getUserListFromFarm(farmId: string): Promise<UserDto[]> {
    const response = await this.service.getUserListFromFarm(farmId)
    return response.data
  }

  public async changePassword(changePasswordDto: ChangePasswordDto): Promise<void> {
    await this.service.changePassword(changePasswordDto)
  }

  public async checkEmail(email: string): Promise<{ errorMessage?: string }> {
    const response = await this.service.checkEmail(email)
    return response.data
  }

  public async changeProfile(farmId: string, changeProfileDto: UserParams): Promise<UserDto> {
    const response = await this.service.changeProfile(farmId, changeProfileDto)
    return response.data
  }

  public async registerUser(payload: any): Promise<LoginResponse> {
    const response = await this.service.registerUser(payload)
    return response.data
  }

  public async resetPassword(username: string): Promise<void> {
    await this.service.resetPassword(username)
  }

  public async sendConfirmationCode(username: string, tipo: 'TELEFONE' | 'EMAIL'): Promise<void> {
    await this.service.sendConfirmationCode(username, tipo)
  }

  public async validateConfirmationCode(username: string, codigo: string, tipo: 'TELEFONE' | 'EMAIL'): Promise<void> {
    await this.service.validateConfirmationCode(username, codigo, tipo)
  }
}
